import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CrewChangeServices } from '../crew-change.service';
import { DateTimeHelpers } from '../../../../shared/helpers/date-time.helpers';
import moment from 'moment/moment';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CrewChange, Crew } from 'src/app/generated/services/transportation/crew/crew';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-crew-assignments',
  templateUrl: './crew-assignments.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule, RouterModule, MatCardModule, MatTableModule, MatButtonModule, MatIconModule ]
})
export class CrewAssignmentsComponent {

  selectedCrewPreviousAssignments: CrewChange[] = [];
  displayedColumns: string[] = ['vesselName', 'from', 'to', 'rank', 'duration', 'status'];
  _crew!:Crew;

  @Input()
  set crew(value: Crew) {
    if(value) {
      this._crew = value;
      this.selectedCrewPreviousAssignments = value.crewChanges;
    }
  }

  constructor(private _crewChange: CrewChangeServices) { }

  dateTime(timestamp: number) {
    if (timestamp) {
      return DateTimeHelpers.formatLocalDateTime(timestamp);
    }
  }

  crewChangeFindPlan(ch: CrewChange, plan: string) {
    return ch.item?.find(c => c.plan === plan);
  }

  duration(ch: CrewChange) {
    const on = this.crewChangeFindPlan(ch, 'On Board');
    const off = this.crewChangeFindPlan(ch, 'Off Board');
    if (on && off) {
      return moment(off?.time)
        .diff(moment(on?.time), 'months', true)
        .toFixed(2);
    } else {
      return '-';
    }
  }

}
